import React, {useEffect, useRef} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import AdyenCheckout from "@adyen/adyen-web";
import '@adyen/adyen-web/dist/adyen.css';
import {useSelector, useDispatch} from "react-redux";

import styles from './Checkout.module.scss';

import {ADYEN_CLIENT_KEY, ADYEN_RETURN_URL, ENV_ADYEN} from "../../shared/constants";
import PopupInfo from "../../components/PopupInfo/PopupInfo";
import Loading from "../../components/Loading/Loading";
import withRequestHandler from "../../HOC/withRequestHandler";
import {clearSelectedOffer, startPurchaseIntention} from "../../redux/rootReducer";

const Checkout = ({ config, makeRequest, isLoading }) => {
    let isFirstPageView = useRef(true);
    const navigate = useNavigate();
    const { state } = useLocation();
    let transactionId = useRef();
    const { error, selectedOffer } = useSelector(state => state.rootReducer);
    const dispatch = useDispatch();

    let player = localStorage.getItem('shishiPlayerInfo');
    player = JSON.parse(player);

    const initAdyenSession = async () => {
        const response = await makeRequest('post', 'startPurchase', {
            redirectUrl: ADYEN_RETURN_URL,
            username: player.username,
            userId: player.userId,
            email: state.email,
            pack: selectedOffer
        });

        if (response && !response.intentionId) {
            dispatch(clearSelectedOffer());
            navigate('/checkout-result', { state: {success: false} });
            return;
        }

        const googlePayConfiguration = {
            //Set this to PRODUCTION when you're ready to accept live payments
            environment: ENV_ADYEN === 'live' ? "PRODUCTION" : "TEST",
            // merchantName: 'shishi',
            // gatewayMerchantId: 'Shishi',
            gateway: "adyen",
            gatewayMerchantId: "Shishi",
            merchantId: 'BCR2DN4T2SB7JD2U',
            "tokenizationSpecification": {
                "type": "PAYMENT_GATEWAY",
                "parameters": {
                    "gateway": "adyen",
                    "gatewayMerchantId": "Shishi"
                }
            }
        };

        const translations = {
            // Locale being customized or created
            "ja-JP": {
                // Define text that appears in payment form
                "storeDetails": "次回以降のご購入の際に、今回のお支払い情報をご利用される場合は、チェックマークいれてください。（弊社のサーバ内にお支払い情報は保存いたしません。決済代行会社のAdyen（アディエン）のサーバ上に保存されます）",
            }
        };
        const parsedSessionData = response.sessionDataJson;
        transactionId = response.intentionId;
        const configuration = {
            environment: ENV_ADYEN, // Change to 'live' for the live environment.
            clientKey: ADYEN_CLIENT_KEY, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
            session: parsedSessionData,
            onPaymentCompleted: (result, component) => {
                dispatch(clearSelectedOffer());
                if (result.resultCode == 'Authorised') {
                    navigate('/checkout-result', {state: {success: true, transactionId: transactionId}});
                } else {
                    navigate('/checkout-result', { state: {success: false} });
                }
            },
            onError: (error, component) => {
                dispatch(clearSelectedOffer());
                navigate('/checkout-result', { state: {success: false} });
            },
            // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
            // For example, this is 3D Secure configuration for cards:
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    billingAddressRequired: false,
                    enableStoreDetails: true,
                },
            },
            locale: "ja-JP",
            translations: translations,
        };

        // Create an instance of AdyenCheckout using the configuration object.
        const checkout = await AdyenCheckout(configuration);

        // Create an instance of Drop-in and mount it to the container you created.
        const dropinComponent = checkout.create('dropin').mount('#dropin-container');
    }

    useEffect( () => {
        dispatch(startPurchaseIntention());
        initAdyenSession();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    useEffect(() => {
        if (isFirstPageView.current) {
            window.gtag('event', 'screen_view', {
                'app_name': 'Shishi shop',
                'screen_name': 'page_payment_gateway'
            });
            window.gtag('event', 'page_view', {
                'app_name': 'Shishi shop',
                'page_title': 'payment'
            });
            isFirstPageView.current = false;
        }
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>{config.checkout}</div>
            <div id="dropin-container"></div>
            {isLoading ? <Loading withOverlay={true} /> : null}
            {error.hasError ? <PopupInfo text={error.message} /> : null}
        </div>
    );
};

export default withRequestHandler(Checkout);